import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Blog.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5002";

const getImageSrc = (imageUrl) => {
  if (!imageUrl) return "";
  return imageUrl.startsWith("http") ? imageUrl : `${API_URL}${imageUrl}`;
};

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [mainPost, setMainPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false,
      mirror: true,
    });
  }, []);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/posts`);

        const fetchedPosts = Array.isArray(res.data) ? res.data : [];

        const sortedPosts = [...fetchedPosts].sort((a, b) => {
          const dateA = new Date(a.createdAt || a.updatedAt || 0).getTime();
          const dateB = new Date(b.createdAt || b.updatedAt || 0).getTime();
          return dateB - dateA;
        });

        setPosts(sortedPosts);
        setMainPost(sortedPosts[0] || null);
      } catch (err) {
        console.error("❌ Erreur chargement articles :", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  if (loading) {
    return <p style={{ padding: "2rem" }}>Chargement des articles...</p>;
  }

  if (!mainPost) {
    return (
      <div className="blog-empty" data-aos="fade-up">
        <h3>Aucun article disponible pour le moment</h3>
        <p>Les actualités apparaîtront ici bientôt.</p>
      </div>
    );
  }

  return (
    <div className="post-page">
      <div className="main-article" data-aos="fade-right">
        <span className="blog-badge">News</span>
        <h2>{mainPost.title}</h2>

        {mainPost.imageUrl && (
          <img
            src={getImageSrc(mainPost.imageUrl)}
            alt={mainPost.title}
            className="post-image"
          />
        )}

        <p className="blog-excerpt">
          {mainPost.excerpt || `${mainPost.content?.slice(0, 250)}...`}
        </p>

        <Link to={`/post/${mainPost._id}`} className="blog-read-more">
          Lire l’article complet →
        </Link>
      </div>

      <div className="sidebar" data-aos="fade-left">
        <h3>Articles précédents</h3>
        {posts.slice(1, 5).map((post, index) => (
          <Link
            to={`/post/${post._id}`}
            key={post._id}
            className="sidebar-post"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            {post.imageUrl && (
              <img src={getImageSrc(post.imageUrl)} alt={post.title} />
            )}
            <p>{post.title}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;